'use client';

import { ButtonLink } from '@packages/shared/src/ui/Button/Button';

/**
 * This component shows static content for an error page
 *
 * @param title contains title
 * @param description contains description
 * @param buttonLabel contains label of back button
 * @returns JSX.Element to be placed in Error Pages
 */
export type StaticErrorContentProps = {
  title: string;
  description?: string;
  description2?: string;
  buttonLabel?: string;
};

export const StaticErrorContent = ({
  title,
  description,
  description2,
  buttonLabel,
}: StaticErrorContentProps) => (
  <div className="flex flex-col items-center justify-center gap-2.5 px-2 pt-5 pb-2.5">
    <p className="text-size-headline-2xl text-center font-bold">{title}</p>
    <span className="icon-emp-coffee-cat size-[12rem]" />
    <div className="text-size-body-base text-center">
      <p>{description}</p>
      <p>{description2}</p>
    </div>
    <ButtonLink color="primary" href="/">
      {buttonLabel}
    </ButtonLink>
  </div>
);
